<div class="row">

</div>
<div class="row mb-4">
    <div class="col-12 mb-4">
        <div class="card card-custom">
            <div class="card-body">
                <div class="my-card-title-with-tools">
                    <div class="title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M4,7 L20,7 C21.1045695,7 22,7.8954305 22,9 L22,19 C22,20.1045695 21.1045695,21 20,21 L4,21 C2.8954305,21 2,20.1045695 2,19 L2,9 C2,7.8954305 2.8954305,7 4,7 Z M16,18 C18.209139,18 20,16.209139 20,14 C20,11.790861 18.209139,10 16,10 C13.790861,10 12,11.790861 12,14 C12,16.209139 13.790861,18 16,18 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M20.6185961,7.09750181 C20.4238038,7.03420884 20.2158968,7 20,7 L17.2014013,7 L8.01276516,1.87327098 C7.53047091,1.60417861 7.35763664,0.995059403 7.62672902,0.512765158 C7.89582139,0.0304709116 8.5049406,-0.142363355 8.98723484,0.126729018 L20.1117466,6.33356496 C20.4052818,6.49734071 20.5841864,6.78706979 20.6185961,7.09750181 Z" fill="#000000"/>
                                    <path d="M16,16 C17.1045695,16 18,15.1045695 18,14 C18,12.8954305 17.1045695,12 16,12 C14.8954305,12 14,12.8954305 14,14 C14,15.1045695 14.8954305,16 16,16 Z" fill="#000000"/>
                                    <rect fill="#000000" opacity="0.3" x="4" y="11" width="5" height="2" rx="1"/>
                                    <rect fill="#000000" opacity="0.3" x="4" y="15" width="5" height="2" rx="1"/>
                                </g>
                            </svg>
                        </span>
                        <h5>HTML5 Player Streams</h5>
                    </div>
                    <div class="tools">
                        <button mat-icon-button color="primary" (click)="getStreams()">
                            <mat-icon aria-label="Refresh">autorenew</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-right" [formGroup]="streamsSettingsForm">
                        <mat-form-field>
                            <mat-select placeholder="Stream status" formControlName="streamStatus" (selectionChange)="getStreams()">
                                <mat-option *ngFor="let status of statuses" [value]="status.value">
                                    {{ status.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingStreams$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingStreams$ | async) &&!(hasStreams$ | async)">No streams found!</div>
                <div *ngIf="!(loadingStreams$ | async) && (hasStreams$ | async)" class="table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th scope="col">Webpage</th>
                            <th scope="col">Stream Information</th>
                            <th scope="col">Player</th>
                            <th scope="col" class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let stream of streams$ | async">
                            <ng-container [ngTemplateOutlet]="StreamItemTemplate" [ngTemplateOutletContext]="{item: stream}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #StreamItemTemplate let-item="item">
    <tr>
        <td nowrap class="table-row">
            <a target="_blank" href="{{item.webpage}}">{{item.webpage | maxCharacters: 50}}</a>
        </td>
        <td nowrap class="table-row">{{item.streamUrl | maxCharacters: 50}}</td>
        <td nowrap class="table-row">{{item.getPlayerName()}}</td>
        <td nowrap class="table-row text-center">
            <button *ngIf="item.streamStatus === 1" mat-icon-button color="accent" (click)="updateStreamStatus(item.id, 2)">
                <mat-icon aria-label="More information">local_library</mat-icon>
            </button>
            <button *ngIf="item.streamStatus === 1" mat-icon-button color="warn" (click)="updateStreamStatus(item.id, 3)">
                <mat-icon aria-label="More information">delete</mat-icon>
            </button>
            <button *ngIf="item.streamStatus === 1 || item.streamStatus === 2" mat-icon-button color="primary" (click)="updateStreamStatus(item.id, 4)">
                <mat-icon aria-label="More information">done</mat-icon>
            </button>
        </td>
    </tr>
</ng-template>